import { ReactElement, useCallback, useMemo, useState } from 'react'
import Accordion from '../../../../components/Accordion'
import accordions from './accordions'
import * as S from './styled'

export default function Faq (): ReactElement {
  const [activeAccordion, setActiveAccordion] = useState<number>()
  const [viewMore, setViewMore] = useState(false)

  const handleOnOpen = useCallback((newIndex?: number): void => setActiveAccordion(newIndex), [])

  const displayedAccordions = useMemo(() => viewMore ? accordions : accordions.slice(0, 4), [viewMore])

  return <S.Container id="faq">
    <h1>Perguntas frequentes</h1>

    <S.Content>
      {displayedAccordions.map(({ description, title }, index) => <Accordion
        index={index}
        key={title}
        onOpen={handleOnOpen}
        title={title}
        isOpen={activeAccordion === index}
      >
        <S.AccordionContent dangerouslySetInnerHTML={{ __html: description }} />
      </Accordion>)}
    </S.Content>

    <S.ViewMoreButton onClick={() => setViewMore(!viewMore)}>
      {viewMore ? 'Ver menos dúvidas' : 'Ver mais dúvidas'}
    </S.ViewMoreButton>
  </S.Container>
}
